import Vue from 'vue'
import Router from 'vue-router'
import store from './../store'
import system from './modules/system'
import auth from './modules/auth'
import users from './modules/users'
import roles from './modules/roles'
import dashboards from './modules/dashboards'
import notifications from './modules/notifications'
import orders from './modules/Order'


Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (savedPosition) {
      return savedPosition;
    } else if (to.hash) {    
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    ...system,
    ...auth,
    ...users,
    ...dashboards,
    ...notifications,
    ...roles,
    ...orders,
  ]
})

/// ////////////////////
// Before Each Route //
/// ////////////////////
router.beforeEach(async (to, from, next) => {
 
  // load view layout
  store.commit('app/setLayout', to.meta.layout + '-layout')

  // check if vuex has auth else fetch from local (in case of page refresh)
  if (localStorage.getItem('token') != null && store.getters['user.token'] == null) {
    store.commit('user/setAuth')
  }

  // Auth Required Pages
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        name: 'login'
      })
    } else {
      next()
    }

    // guest only pages
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: 'dashboard'
      })
    }
    // pages for both guest and authorized users
  } else {
    next()
  }
})

export default router
